export interface ActionableEvent {
  id: number;
  loan_application_id: number;
  name: string;
  message: string;
  data: any;
  acknowledged_at: string | null;
  created_at: string;
}

export enum ActionableEvents {
  ActualNetProceedsChangeEvent = "actual_net_proceeds_change_event",
  CashOfferPurchaseCOEDateChangeEvent = "cash_offer_close_of_purchase_escrow_change_event",
  CashOfferSellCOEDateChangeEvent = "cash_offer_close_of_sell_escrow_change_event",
  LoanDownpaymentChangeEvent = "loan_downpayment_change_event",
  NetProceedsChangeEvent = "net_proceeds_change_event",
  TradeInCOEDateChangeEvent = "trade_in_close_of_escrow_change_event",
  RateLockChangeEvent = "rate_lock_change_event",
}

export const getEventMessage = (eventName: ActionableEvents): string => {
  switch (eventName) {
    case ActionableEvents.LoanDownpaymentChangeEvent:
      return "Downpayment has been updated. Please redisclose.";
    case ActionableEvents.RateLockChangeEvent:
      return "Rate Lock has changed";
    default:
      return "";
  }
};
